<template>
  <div class="container">
    <div class="home-banner">
        <img class="banner-bg" src="@/assets/ridianxinw.png" alt="">
        <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">热点新闻</p>
        </div>
    </div>
    <div class="single" v-if="id == 1">
      <h2>部盾科技CEO部瑞志博士与上海证券交易所联合课题项目成功通过验收</h2>
      <h5>发布日期 2019-03-09</h5>
      <div class="content">
        <p>近日，在部盾科技部瑞志博士主导下，与上海证券交易所（以下简称“上交所”）联合课题项目——“<strong>基于资本市场科技监管的企业画像研究</strong>”，在经过项目总结汇报与专家评审后，成功通过了上交所证券信息技术研究发展中心组织的项目验收。</p>
        
        <p>&nbsp;本次课题以部盾生命周期动态模拟（DSS）为理论及技术支撑，通过大数据分析进行实证研究，以为一级融资市场和二级交易市场中的监管职能提供抓手为目标，同时也为各种类型投资者提供针对企业财务运行的画像分析以做为投资决策的实证依据。本次研究中所针对的决策主体和决策场景包括：为监管职能实施中所需的财务表现监控、违约风险预警、财务报告异动识别和所触发的企业尽调提供手段和数据依据；为提高资本市场的流动性提供有效的决策信息，以简化和加速决策过程；为二级市场投资者的决策及时推送画像分析。其中，作为本课题核心内容的上市公司和发债企业财务粉饰识别和信用预警等应用，不仅满足了监管部门对上市公司和发债企业的创新性监管需求，同时也为资本市场投资者提供了有力的投资决策依据和实用工具。</p>
        
        <p>&nbsp;</p>
        
        <p>部盾科技CEO，课题项目组组长部瑞志博士，曾任美国富国银行风控总监、阿格斯信息和咨询公司高级副总裁和预测首席科学家，在金融风控领域具有二十多年的实践经验。部瑞志博士建立的生命周期动态模拟（DSS）的理论和技术是美国联储领导的金融业压力测试和企业风险评估主要工具，方法进入美国(CECL)和欧洲(IFRS9)金融业会计报告准则，并为各大银行贷款业务提供风控管理。</p>
        
        <p>本课题成功通过验收，标志着部盾科技作为大数据决策分析先行者，正在为我国充分发挥金融科技在引导资本市场健康规范发展中的积极作用成功赋能。</p>
        
        <p><a @click="goView('quyu')">部盾赋能金融行业详情</a></p>
      </div>
    </div>   
    <div class="single" v-if="id == 2">
        <h2>部盾科技CEO部瑞志博士与上海金融圈分享金融风险防范</h2>
        <h5>发布日期 2018-10-10</h5>
        <div class="content">
        <p style="text-align: left;">2018年10月10日部盾科技CEO部瑞志博士做客“陆家嘴金融之家投资沙龙”，与金融界人士热烈探讨了生命周期动态模拟技术（DSS）对上市发债的违约风险预测、财务报告异常画像、税收风险管理、行业和地域经济预测、网络科技和教育大数据等决策中的应用。</p>
        
        <p>任何事物都有其自身的规律。历史上的金融危机是否可以防范？金融危机的产生有什么共性？我们在过去的教训中学会了什么？我们该如何吸取历史经验来对现在的金融风险进行防范？伴随着这些疑问，在美欧市场的压力测试及FRS9中占据重要地位的生命周期动态模拟技术（DSS）如何帮助金融投资人士更高效地达成金融风险防范目标，成为了现场最为关注的议题。部瑞志博士深入浅出地介绍了部盾生命周期动态模拟技术（DSS）的原理和在金融风险防范场景中的实际应用，为现场嘉宾开拓思路寻找金融风险防范的坚实盾牌指明方向。</p>
        
        <p><a @click="goView('jinrong')">部盾赋能金融行业详情 </a></p>
        </div>
    </div> 
    <div class="single" v-if="id == 3">
        <p>&nbsp;</p>
        <div>&nbsp;</div>
        <p>&nbsp;</p>
        <div>&nbsp;</div>
        <div class="single">
          <h2>部盾科技助力ATA发布《2018年ATA就业力报告》</h2>
          <h5>发布日期 2018-12-20</h5>
          <div class="content"> 2018年12月20日，ATA（全美在线）在北京成功发布《2018年ATA就业力报告》。部盾科技作为大数据决策分析的先行者为本次报告提供了全景式数据分析支持。  ATA（全美在线）长期致力于企业人才招聘、校园招聘和人才评价服务，专注并精耕校园招聘考试服务市场，为众多企业提供了校园招聘考试服务。每年有超过百万人次的应届毕业生通过ATA（全美在线）提供的考试测评服务参加各大企业的校园招聘，ATA职业能力评价研究院基于海量考试评价数据研究编制的《2018ATA就业力报告》，构建了2018年高校毕业生的能力画像，展现了就业市场的新特点和新趋势。</div>
          <div class="content"><img src="@/assets/ata.png"></div>
        </div>
      <div>&nbsp;</div>
    </div>
    <div class="single" v-if="id == 4">
      <h2>部盾科技获得《税务研究》杂志征文优秀奖</h2>
      <h5>发布日期 2019-06-01</h5>
      <div class="content">
      <p class="has-normal-font-size">奔走于税企合作助力“互联网+税务”的企业代表，他们站在高的起点上，用新的理念深层次研究“互联网+税务”，提出创新变革的新思想、新路径、新举措，助推“互联网+ 税务”再上新台阶。</p>
      <p class="has-normal-font-size" style="text-align: right;">&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; -------------“互联网+ 税务”专题征文主办方</p>
      
      <p>&nbsp;</p>
      
      <p>在2018年《税务研究》与腾讯公司联合举办的“互联网+ 税务”专题征文活动中，由部盾科技与罗格数科共同合作的"互联网+税务"课题组凭借“生命周期动态模拟技术及其在税收领域应用初探”一文，在162篇论文中脱颖而出，获得优秀奖。</p>
      
      <p>作为唯一一篇企业获奖论文，部盾科技与罗格数科共同阐述了生命周期动态模拟技术（DSS）的理论基础及核心概念，并着重探讨了生命周期动态模拟技术（DSS）如何在税收领域，诸如纳税人群体分析、税收收入预测、对纳税信用动态评分和建立纳税人动态画像、税收政策效应分析等方面，为管理者提供可信赖可落地的决策依据。</p>
      
      <p>为贯彻落实党中央、国务院推进“互联网+”行动的战略部署和国家税务总局《“互联网+ 税务”行动计划》的明确要求，深入研究“互联网+”对税收工作的影响，有力推进税收现代化建设，中国税务杂志社与腾讯公司于2018年联合举办了本次专题征文活动，以期通过对“互联网+税务”专题的深入探讨，链接新技术、新产业、新业态、新模式，从税收角度分析研讨新技术带来的“互联网+”新生态。</p>
      
      <p>部盾科技作为大数据决策分析领域的先行者，致力于在新技术与传统行业的融合中用历史成就现在、揭示未来，创造性地以生命周期动态模拟技术（DSS）与税务大数据对话，为内蒙古、山东、浙江等税局实现“互联网+ 税务”赋能。</p>
      
      <p><a @click="goView('shuiju')">部盾赋能税务行业案例详情</a></p>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-76" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技《税务研究》杂志征文1.png" alt=""></figure>
      </div>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-77" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技《税务研究》杂志征文2-746x1024.png" alt=""></figure>
      </div>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-78" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技《税务研究》杂志征文3-746x1024.png" alt=""></figure>
      </div>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-79" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技《税务研究》杂志征文4-746x1024.png" alt=""></figure>
      </div>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-80" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技《税务研究》杂志征文5-746x1024.png" alt=""></figure>
      </div>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-81" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技《税务研究》杂志征文6-746x1024.png" alt=""></figure>
      </div>
      <div class="wp-block-image">
      <figure class="aligncenter"><img class="wp-image-82" src="https://www.bu-dun.com/wp-content/uploads/2019/08/部盾科技获得《税务研究》杂志征文优秀奖-获奖名单-402x1024.jpg" alt=""></figure>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetails",
  data() {
    return {
      id: 1
    };
  },
  methods: {
    goView(name) {
      this.$router.push({name: name})
    },
  },
  mounted() {
    this.id = this.$route.query.id
  },
}
</script>

<style scoped>
   
</style>